const COMPANY_NAME=process.env.REACT_APP_COMPANY_NAME;
const ALIAS=process.env.REACT_APP_COMPANY_ALIAS;
const CONTACT_EMAIL=process.env.REACT_APP_CONTACT_EMAIL;
const GOOGLE_PAYMENTS="https://payments.google.com/payments/apis-secure/u/0/get_legal_document?ldo=0&ldt=privacynotice&ldl=en-US";
const APPLE_PAYMENTS="https://www.apple.com/legal/privacy/data/en/app-store/";

const ADDRESS_LINE_1=process.env.REACT_APP_ADDRESS_LINE_1;
const ADDRESS_LINE_2=process.env.REACT_APP_ADDRESS_LINE_2;
const ADDRESS_LINE_3=process.env.REACT_APP_ADDRESS_LINE_3;

const AD_CLIENT=process.env.REACT_APP_DATA_AD_CLIENT;
const AD_SLOT=process.env.REACT_APP_DATA_AD_SLOT;

const REPRESENTATIVE=process.env.REACT_APP_REPRESENTATIVE;
const UST_ID=process.env.REACT_APP_UST_ID;
const WIR_ID=process.env.REACT_APP_WIR_ID;

const WIN_URL_LATEST=process.env.REACT_APP_WIN_URL_LATEST;
const MAC_URL_LATEST=process.env.REACT_APP_MAC_URL_LATEST;
const DEBIAN_URL_LATEST=process.env.REACT_APP_DEBIAN_URL_LATEST;
const UBUNTU_URL_LATEST=process.env.REACT_APP_UBUNTU_URL_LATEST;

const WINDOWS_VERSION="10";
const MAC_VERSION="Mojave (10.15)";
const DEBIAN_VERSION="10";
const UBUNTU_VERSION="20.04 LTS";
const IOS_VERSION="17.4";
const ANDROID_VERSION="5";

const GOOGLE_PLAY_LINK=process.env.REACT_APP_GOOGLE_PLAY_LINK
const APP_STORE_LINK=process.env.REACT_APP_APP_STORE_LINK


export {GOOGLE_PLAY_LINK, APP_STORE_LINK, WINDOWS_VERSION, MAC_VERSION, DEBIAN_VERSION, UBUNTU_VERSION, IOS_VERSION, ANDROID_VERSION, DEBIAN_URL_LATEST, UBUNTU_URL_LATEST, COMPANY_NAME, ALIAS, CONTACT_EMAIL, GOOGLE_PAYMENTS, APPLE_PAYMENTS, ADDRESS_LINE_1, ADDRESS_LINE_2, ADDRESS_LINE_3, AD_CLIENT, AD_SLOT, REPRESENTATIVE, UST_ID, WIR_ID, WIN_URL_LATEST, MAC_URL_LATEST};